import React, { memo, useEffect } from 'react';
import { RendererClient } from '../internal';
import { fillParentStyles } from './util';

export type PagePreviewOverlayProps = {
  rendererClient: RendererClient;
};

export const PagePreviewOverlay: React.FC<PagePreviewOverlayProps> = memo(
  function PagePreviewOverlay({ rendererClient }) {
    // Set the renderer to interactive mode to allow scrolling.
    useEffect(() => {
      rendererClient.setMode({ mode: 'interactive', cursor: 'default' });
    }, [rendererClient]);

    return (
      <div
        data-testid="page-preview-overlay"
        role="none"
        tabIndex={-1}
        style={{
          ...fillParentStyles,
          position: 'absolute',
          top: 0,
          left: 0,
          pointerEvents: 'none',
        }}
      />
    );
  },
);
